// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8c9446c9","453":"09f45222","455":"babc50ae"}[chunkId] + ".chunk.js";
};